import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {toast} from 'react-toastify'
import {LoadingData} from '../../../../components/LoadingData'
import {ModeleDelaisTraitement} from '../../../../components/Models'
import {getAllDelaisTraitement} from '../../../../components/requests'
import {ModeleSavParametre} from '../../../../components/sav/Models'
import {getSavParametres, savErreur, updateSavParametre} from '../../../../components/sav/requests'

const SEUIL = 'SEUIL_VALIDATION_AVOIR'
const UNITES: Record<string, string> = {j: 'j', h: 'h', mn: 'min'}

// Onglet Paramètres de l'écran Référentiels SAV (écran 10.4)
const SavParametresTab = () => {
  const [loading, setLoading] = useState(false)
  const [enregistrement, setEnregistrement] = useState(false)
  const [parametres, setParametres] = useState<Array<ModeleSavParametre>>([])
  const [seuil, setSeuil] = useState('')
  const [delais, setDelais] = useState<Array<ModeleDelaisTraitement>>([])

  const appliquer = (liste: Array<ModeleSavParametre>) => {
    setParametres(liste)
    setSeuil(liste.find((p) => p.cle === SEUIL)?.valeur ?? '')
  }

  useEffect(() => {
    setLoading(true)
    Promise.all([getSavParametres(), getAllDelaisTraitement()])
      .then(([liste, reponseDelais]) => {
        appliquer(liste)
        setDelais(
          (reponseDelais?.data ?? []).filter(
            (d: ModeleDelaisTraitement) =>
              d.actif && d.typeDelaiTraitementDemande?.code?.startsWith('SAV_')
          )
        )
      })
      .catch((e) => toast.error(savErreur(e)))
      .finally(() => setLoading(false))
  }, [])

  const enregistrer = (e: React.FormEvent) => {
    e.preventDefault()
    setEnregistrement(true)
    updateSavParametre(SEUIL, seuil)
      .then((liste) => {
        appliquer(liste)
        toast.success('Seuil enregistré')
      })
      .catch((e) => toast.error(savErreur(e)))
      .finally(() => setEnregistrement(false))
  }

  if (loading) return <LoadingData />

  const parametreSeuil = parametres.find((p) => p.cle === SEUIL)

  return (
    <div className='row g-5'>
      <div className='col-lg-6'>
        <form className='bg-light rounded p-6 h-100' onSubmit={enregistrer}>
          <h4 className='mb-4'>Validation des avoirs</h4>
          <label className='form-label fw-bold' htmlFor='seuil'>
            Seuil au-delà duquel le responsable SAV valide l'avoir (€ HT)
          </label>
          <input
            id='seuil'
            className='form-control form-control-solid mb-3'
            inputMode='decimal'
            value={seuil}
            onChange={(e) => setSeuil(e.target.value)}
          />
          <div className='text-muted mb-2'>
            Un avoir sur un prix déclaré demande toujours la validation du responsable SAV.
          </div>
          {parametreSeuil?.dateModification && (
            <div className='text-muted fs-7 mb-4'>
              Modifié le {new Date(parametreSeuil.dateModification).toLocaleString('fr-FR')}
              {parametreSeuil.utilisateurModif && ` par ${parametreSeuil.utilisateurModif}`}
            </div>
          )}
          <button
            type='submit'
            className='btn btn-success'
            disabled={enregistrement || seuil.trim() === ''}
          >
            {enregistrement ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </form>
      </div>
      <div className='col-lg-6'>
        <div className='bg-light rounded p-6 h-100'>
          <h4 className='mb-4'>Délais de traitement SAV</h4>
          <div className='text-muted mb-4'>
            Ils sont gérés dans l'écran Paramètres › Délais de traitement, types « SAV – … ».
          </div>
          {delais.length ? (
            <ul className='mb-5'>
              {delais.map((d) => (
                <li key={d.id}>
                  {d.typeDelaiTraitementDemande?.libelle ?? d.libelle} :{' '}
                  <strong>
                    {d.duree} {UNITES[d.unite] ?? d.unite}
                  </strong>
                </li>
              ))}
            </ul>
          ) : (
            <div className='alert alert-warning'>Aucun délai SAV actif.</div>
          )}
          <Link to='/delais-traitement' className='btn btn-light-primary'>
            Ouvrir Délais de traitement
          </Link>
        </div>
      </div>
    </div>
  )
}

export default SavParametresTab
